"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivePartnerFeatureIds = void 0;
const partner_data_client_1 = require("@evenfinancial/partner-data-client");
const getActivePartnerFeatureIds = (activePartnerFeatures) => {
    const noRemarketingFeature = activePartnerFeatures.find(({ feature }) => feature === partner_data_client_1.PartnerFeature.NoRemarketing);
    return { noRemarketingFeatureId: noRemarketingFeature === null || noRemarketingFeature === void 0 ? void 0 : noRemarketingFeature.id };
};
exports.getActivePartnerFeatureIds = getActivePartnerFeatureIds;
